import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { getProfileQueryKey } from 'features/users';
import { sync } from '../services';
import type { SyncDexcomRequest } from '../services/data-objects';

export const useSyncAccount = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, SyncDexcomRequest>({
    async mutationFn(data: SyncDexcomRequest) {
      await sync(data);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
